/**
 * Attributions Modal
 *
 * Displays credits and attributions for the game.
 * Follows RulesModal styling patterns.
 */

import React from 'react';
import { useTranslation } from '../i18n/index.js';
import './AttributionsModal.css';

export default function AttributionsModal({ onClose }) {
  const { t } = useTranslation();

  return (
    <div className="attributions-modal-overlay" onClick={onClose}>
      <div className="attributions-modal" onClick={(e) => e.stopPropagation()}>
        <button className="attributions-close-btn" onClick={onClose}>
          &times;
        </button>

        <h2>{t('attributions.title')}</h2>

        <div className="attributions-content">

          <div className="attribution-item">
            <h3>{t('attributions.gameDesignTitle')}</h3>
            <p>{t('attributions.gameDesignBy')}</p>
          </div>

          <div className="attribution-item">
            <h3>{t('attributions.developmentTitle')}</h3>
            <p>{t('attributions.developedBy')}</p>
          </div>

          <div className="attribution-item">
            <h3>{t('attributions.builtWithTitle')}</h3>
            <p>{t('attributions.builtWith')}</p>
          </div>

        </div>

        <a
          href="https://git.soundworker.de/jakob/waterloo"
          target="_blank"
          rel="noopener noreferrer"
          className="source-code-btn"
        >
          {t('attributions.showSourceCode')} ↗
        </a>
      </div>
    </div>
  );
}
